import { TransactionChangeLog } from '@ui/src';
import { useAppSelector } from '@store';
import useGetPspPartnersAutocompleteList from '../../../store/dictionaries/helpers/use-psp-partners-autocomplete';

const TransactionFeeChangeLog = (): React.JSX.Element => {
  const {
    transactionFee: { transaction },
  } = useAppSelector((state) => state);

  const { autocompleteList: pspPartners } =
    useGetPspPartnersAutocompleteList('');

  return (
    <TransactionChangeLog
      changeLogs={transaction?.logs?.edges.map((item) => item.node)}
      pspPartners={pspPartners}
    />
  );
};

export default TransactionFeeChangeLog;
